export default __webpack_public_path__ + "static/media/project.570fa9d0.svg";